
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { memberTable } from "./table-columns";
import i18n from "@/config/i18n";
import {
  getOptChart,
  getOptGrid,
  getOptActiveGrid,
  getOptTodayChart
} from "@/api/api-operation-service";
import detailEchart from "./detail-echart.vue";

@Component({
  components: {
    "pi-detail-echart": detailEchart
  }
})
export default class PiDataModal extends Vue {
  private detailEchart: objAny = {};

  @Prop({
    default: () => {
      return {};
    }
  })
  private formData!: objAny;
  private modalShow = false;
  private title = "";
  private tabsActive = "name1";
  private total = 0;
  private loading = false;
  private tableList: object[] = [];
  private tableColumns: object[] = [];
  private tableColumnsInit: object[] = [
    {
      title: i18n.t("commonTableName.staName"),
      key: "staName",
      minWidth: 110
    },
    {
      title: i18n.t("commonTableName.pileName"),
      key: "pileName",
      minWidth: 110
    },
    {
      title: i18n.t("commonTableName.gunName"),
      key: "gunName",
      minWidth: 110
    },
    {
      title: i18n.t("commonTableName.gunPkId"),
      key: "gunPkId",
      minWidth: 130
    }

    // {
    //   title: "电费(元)",
    //   key: "elecAmount",
    //   minWidth: 120
    // },
  ];
  private formInline: objAny = {
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private toDay: objAny = {
    startDate: this["$common"].thisTimes("yyyy-MM-dd"),
    endDate: this["$common"].thisTimes("yyyy-MM-dd")
  };
  private echartType = ""; // 图片是今天(today)还是选择的时候
  private types: number[] = [];
  private echartSeriesType = "";
  private what = "";
  private color = "";
  private chartData: objAny = {};
  public tabChange(data: string): void {
    this.tabsActive = data;
  }
  public open(what: string, color: string, name: string) {
    this.title = name;
    this.color = color;
    this.what = what;
    this.modalShow = true;
    this.tableList = [];
    this.formInline = Object.assign(this.formData, { types: this.types });
    this.formInline.globalPageIndex = 1;
    this.formInline.globalPageSize = 10;
    this.echartType = "";
    this.tabsActive = "name1";
    this.tableColumns = JSON.parse(JSON.stringify(this.tableColumnsInit));
    if (what === "income") {
      // this.title = "收入金额(元)";
      this.tableColumns.push({
        title: this.title,
        key: "totalAmount",
        minWidth: 120
      });
      this.echartSeriesType = "line";
      this.types = [1];
    } else if (what === "order") {
      // this.title = "订单数量(笔)";
      this.tableColumns.push({
        title: this.title,
        key: "orderCount",
        minWidth: 130
      });
      this.types = [2];
      this.echartSeriesType = "bar";
    } else if (what === "elec") {
      // this.title = "充电电量(度)";
      this.tableColumns.push({
        title: this.title,
        key: "totalElec",
        minWidth: 100
      });
      this.types = [3];
      this.echartSeriesType = "bar";
    } else if (what === "people") {
      // this.title = "活跃人数(人)";
      this.types = [4];
      this.echartSeriesType = "line";
      this.tableColumns = JSON.parse(JSON.stringify(memberTable));
    } else if (what === "time") {
      // this.title = "充电时长(小时)";
      this.types = [5];
      this.tableColumns.push({
        title: this.title,
        key: "chargeMins",
        minWidth: 120
      });
      this.echartSeriesType = "line";
    } else if (what === "service") {
      // this.title = "服务费(元)";
      this.types = [6];
      this.tableColumns.push({
        title: this.title,
        key: "serviceAmount",
        minWidth: 130
      });
      this.echartSeriesType = "line";
    }
    this.$nextTick(() => {
      this.detailEchart = this.$refs["detailEchart"];

      this.getOptChart();
    });
  }
  public tabsClick(val: string) {
    if (val == "name2" && this.tableList.length == 0) {
      this.getTableList();
    }
  }
  async getOptChart(): Promise<void> {
    const d = JSON.parse(JSON.stringify(this.formData));
    const json: objAny = Object.assign(d, { types: this.types });

    if (this.echartType == "today") {
      json.startDate = this.toDay.startDate;
      json.endDate = this.toDay.endDate;
    }
    const ret = await getOptChart(this["$common"].forNull(json));
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0];
      const value: number[] = [];
      const time: string[] = [];
      if (data) {
        data.dataList.map((child: objAny) => {
          value.push(child.value);
          time.push(child.name);
        });
      }
      this.chartData.value = value;
      this.chartData.time = time;
      this.chartData.type = this.echartSeriesType;
      this.chartData.color = this.color;
      this.detailEchart.init(this.chartData);
    }
  }
  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    let ret;
    if (this.what === "people") {
      ret = await getOptActiveGrid(this.formInline);
    } else if (this.echartType == "today") {
      ret = await getOptTodayChart({});
    } else {
      ret = await getOptGrid(this.formInline);
    }
    if (ret.status == this["$config"].apiStatus) {
      this.tableList = ret.data;
      this.total = ret.total;
    }
    this.loading = false;
  }

  public rowClick(data: objAny) {
    if (this.what == "people") {
      // this.$router.push("/member-manage/member-list?phoneNo=" + data.phoneNo);
    } else {
      this.$router.push(
        "/oper-manage/charge-order-list?staPkId=" +
          data.staPkId +
          "&pilePkId=" +
          data.pilePkId +
          "&gunPkId=" +
          data.gunPkId
      );
    }
  }
}
